import React, { useEffect, useRef, useState } from 'react'
import './LazyImage.scss'
import LoadingEffect from './LoadingEffect'

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string
    alt: string
    placeholderSrc?: string
    isRightSide?: boolean
}

const LazyImage: React.FC<LazyImageProps> = ({ src, alt, placeholderSrc, className, isRightSide, ...props }) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const imgRef = useRef<HTMLImageElement>(null)

    useEffect(() => {
        const img = new Image()
        img.src = src
        img.onload = () => {
            setIsLoaded(true)
        }
    }, [src])

    return (
        <div
            className={`lazy-image ${className || ''}`}
            style={{ height: props.height ? props.height : undefined, width: props.width ? props.width : undefined }}
        >
            <img
                ref={imgRef}
                src={src}
                alt={alt}
                className={`lazy-image__img ${isLoaded ? 'lazy-image__img--loaded' : ''}`}
                {...props}
            />
            {!isLoaded && isRightSide && (
                <div className="lazy-image__placeholder">
                    <LoadingEffect isVisible={true} isRightSide={true} />
                </div>
            )}
        </div>
    )
}

export default LazyImage
